const START_TIMEOUT = 800;
const initElement = (element) => {
    const phrases = JSON.parse(element.dataset.text || '[]');
    if (!phrases) {
        return;
    }
    let part = '', i = 0, offset = 0, forwards = true, skipCount = 0, skipDelay = 15, speed = 70;
    setInterval(() => {
        if (forwards) {
            if (offset >= phrases[i].length) {
                skipCount++;
                if (skipCount === skipDelay) {
                    forwards = false;
                    skipCount = 0;
                }
            }
        }
        else if (offset === 0) {
            forwards = true;
            i = (i + 1) % phrases.length;
        }
        part = phrases[i].substring(0, offset);
        if (skipCount === 0) {
            forwards ? offset++ : offset--;
        }
        element.textContent = part;
    }, speed);
};
export const initTypingText = (root = document) => {
    const elements = root.querySelectorAll('.typing-text__text');
    if (elements.length === 0) {
        return;
    }
    setTimeout(() => {
        elements.forEach((element) => initElement(element));
    }, START_TIMEOUT);
};
